/**
 * External dependencies
 */
import styled, { css } from 'styled-components';
import { __ } from '@web-stories-wp/i18n';
import { Text } from '@web-stories-wp/design-system';
import {
  TextBorderAlignment,
  TextBorderLineCap,
  TextBorderLineJoin,
  TextBorderStyleType,
  type TextBorder,
} from '@src/web-stories-wp/story-editor/src/elements/types';
import { createSolid } from '@web-stories-wp/patterns';
import { MULTIPLE_VALUE } from '@src/web-stories-wp/story-editor/src/constants';
/**
 * Internal dependencies
 */
import { Row } from '../../../form';

export type MultipleValue = typeof MULTIPLE_VALUE;

export const DEFAULT_TEXT_BORDER: TextBorder = {
  alignment: TextBorderAlignment.Center,
  color: createSolid(0, 0, 0),
  // Butt is the default both in Figma (under "None" option) and in the SVG spec
  lineCap: TextBorderLineCap.Butt,
  // Miter is the default both in Figma and in the SVG spec
  lineJoin: TextBorderLineJoin.Miter,
  // The minimum/default Figma miter limit is 7.17°, which is equivalent to 16 in the SVG spec
  // The SVG spec default would be 4
  miterLimit: 16,
  style: { type: TextBorderStyleType.Solid },
  width: 0,
};

export const TEXT_BORDER_ALIGNMENT_OPTIONS = [
  {
    label: __('Center', 'web-stories'),
    id: TextBorderAlignment.Center,
  },
  {
    label: __('Inside', 'web-stories'),
    id: TextBorderAlignment.Inside,
  },
  {
    label: __('Outside', 'web-stories'),
    id: TextBorderAlignment.Outside,
  },
];

export const TEXT_BORDER_STYLE_OPTIONS = [
  {
    label: __('Solid', 'web-stories'),
    value: TextBorderStyleType.Solid,
  },
  {
    label: __('Dashed', 'web-stories'),
    value: TextBorderStyleType.Dashed,
  },
];

export const Space = styled.div`
  flex: 0 0 8px;
`;

export const Label = styled(Text)`
  flex: 1;
  color: ${({ theme }) => theme.colors.fg.primary};
`;

export const SettingsRow = styled(Row)`
  gap: 16px;
`;

export const TEXT_BORDER_SETTINGS_POPUP_ID = 'text-border-settings-popup';

export function isMultipleValue(value: unknown): value is MultipleValue {
  return typeof value === 'string' && value === MULTIPLE_VALUE;
}

export const SettingsRowInputWrapper = styled.div`
  width: 100%;
  max-width: 140px;
`;
